import {CITY_TOKENS, SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {FORTRESS_CAPTURE_WIN_POINTS, PALACE_CAPTURE_WIN_POINTS} from "../../../configs/winPoints";
import {checkIfCentralQuarter} from "../../buildings/checkIfCentralQuarter";

export const calcPendingBuildingsWinPoints = (pendingBuildings) => {
  let winPoints = 0; // за центральный квартал

  const cityTokenValues = Object.values(CITY_TOKENS);

  pendingBuildings.forEach(({token}) => {
    if(cityTokenValues.includes(token) || checkIfCentralQuarter(token)) {
      winPoints++;

      if (token === SPECIAL_BUILDING_TOKENS.PALACE) {
        winPoints += PALACE_CAPTURE_WIN_POINTS;
      } else if (token === SPECIAL_BUILDING_TOKENS.FORTRESS) {
        winPoints += FORTRESS_CAPTURE_WIN_POINTS;
      }
    }
  })

  return winPoints;
}